var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterliMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3.8623C2.58579 3.8623 2.25 4.19809 2.25 4.6123V13.6123C2.25 14.0265 2.58579 14.3623 3 14.3623H15C15.4142 14.3623 15.75 14.0265 15.75 13.6123V4.6123C15.75 4.19809 15.4142 3.8623 15 3.8623H3ZM0.75 4.6123C0.75 3.36966 1.75736 2.3623 3 2.3623H15C16.2426 2.3623 17.25 3.36966 17.25 4.6123V13.6123C17.25 14.8549 16.2426 15.8623 15 15.8623H3C1.75736 15.8623 0.75 14.8549 0.75 13.6123V4.6123Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.867088 4.96015C1.08924 4.61055 1.55274 4.50724 1.90234 4.72939L8.62745 9.00287C8.73926 9.07249 8.86835 9.10941 9.0001 9.10941C9.13182 9.10941 9.2609 9.0725 9.3727 9.0029L16.0979 4.72939C16.4475 4.50724 16.9109 4.61055 17.1331 4.96015C17.3553 5.30975 17.2519 5.77325 16.9023 5.99541L10.1748 10.2704C10.1735 10.2713 10.1721 10.2721 10.1708 10.273C9.81989 10.4928 9.41418 10.6094 9.0001 10.6094C8.58601 10.6094 8.1803 10.4928 7.8294 10.273C7.82805 10.2721 7.8267 10.2713 7.82535 10.2704L1.09785 5.99541C0.748249 5.77325 0.644933 5.30975 0.867088 4.96015Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterliMail);
export default __webpack_public_path__ + "static/media/footerli_mail.188ce54da1a5f6680972c7264c44274a.svg";
export { ForwardRef as ReactComponent };